import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../reducers'
const selectGroupStore = (state: RootState) => state.groups

export const selectGroupState = createSelector(
  [selectGroupStore],
  groupStore => ({
    groupData: groupStore.data,
    totalCount: groupStore.totalCount,
    currentEntity: groupStore.currentEntity,
    loading: groupStore.loading,
    error: groupStore.error,
    page: groupStore.page,
    pageSize: groupStore.pageSize,
    keyword: groupStore.keyword,
    columnFilters: groupStore.columnFilters,
    sort: groupStore.sort,
    pagination: {
      current: groupStore.page,
      pageSize: groupStore.pageSize,
      total: groupStore.totalCount,
    },
  }),
)

export const selectGroupData = (state: RootState) =>
  selectGroupStore(state).data

export const selectGroupLoading = (state: RootState) =>
  selectGroupStore(state).loading

export const selectGroupError = (state: RootState) =>
  selectGroupStore(state).error

export const selectGroupPagination = (state: RootState) => ({
  current: selectGroupStore(state).page,
  pageSize: selectGroupStore(state).pageSize,
  total: selectGroupStore(state).totalCount,
})
